export var IdealVariantTypes;
(function (IdealVariantTypes) {
    IdealVariantTypes["MODEL"] = "model";
    IdealVariantTypes["CHILD"] = "child";
    IdealVariantTypes["SIMPLE"] = "simple"; // used when products don't have any options to select e.g. product with one option
})(IdealVariantTypes || (IdealVariantTypes = {}));
